import React from "react";
import Contact from "../../components/ContactSection";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import Hero from "./sections/Hero";
import Flota from "./sections/Flota";
import About from "./sections/About";

import HireUs from "./sections/HireUs";
import WhatsappBTN from "../../components/WhatsappBTN";

const Home = () => {
  return (
    <>
      <WhatsappBTN />
      <Header landing />
      <Hero />
      <About />
      <Flota />
      <HireUs />
      <Contact />
      <Footer />
    </>
  );
};

export default Home;
